import { store } from 'helpers';
import { loadPhrasebook } from "store/phrasebook";
import { storageConstants } from '../constants';

import loadLang from "../i18n";


export const languageActions = {
  update
};

function update(lang = undefined) {
  let defaultLanguage;
  if (lang) {
    defaultLanguage = lang;
  } else if (localStorage.getItem(storageConstants.LANGUAGE)) {
    defaultLanguage = localStorage.getItem(storageConstants.LANGUAGE);
  } else {
    defaultLanguage = 'en';
  }
  localStorage.setItem(storageConstants.LANGUAGE, defaultLanguage);
  store.dispatch(loadPhrasebook(loadLang(defaultLanguage)))
}
